"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5165],{

/***/ 5165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



function Card(param) {
    let { component: Component , className , ...other } = param;
    // Location prop somehow causes an error when its passed into this component.
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        className: className,
        ...other
    });
}
Card.propTypes = {
    /**
   * @ignore
   */ component: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
Card.defaultProps = {
    component: "div",
    className: ""
};
/* harmony default export */ __webpack_exports__["default"] = (Card);


/***/ })

}]);